import Vue from 'vue';

const pushGtmEvent = (event, gtmData) => {
    try {
        processDiscountField(gtmData); // Process the discount field

        if (Vue.prototype.$gtm) {
            Vue.prototype.$gtm.trackEvent({
                event: event,
                ecommerce: gtmData.ecommerce,
            });
        } else {
            console.warn('$gtm is not available');
        }
    } catch (error) {
        console.error('Erro ao enviar evento para o GTM:', error);
    }
};

//TODO: Essa funcão deve ser removida quando o backend retornar o valor do desconto como número
const processDiscountField = (gtmData) => {
    if (gtmData && gtmData.ecommerce && Array.isArray(gtmData.ecommerce.items)) {
        gtmData.ecommerce.items = gtmData.ecommerce.items.map(item => {
            if (typeof item.discount === 'string') {
                const discount = parseFloat(item.discount);
                item.discount = isNaN(discount) ? 0 : discount;
            }
            return item;
        });
    }
};

export const trackViewItem = (gtmData) => pushGtmEvent('view_item', gtmData);
export const trackAddToCart = (gtmData) => pushGtmEvent('add_to_cart', gtmData);
export const trackBeginCheckout = (gtmData) => pushGtmEvent('begin_checkout', gtmData);
export const trackAddPaymentInfo = (gtmData) => pushGtmEvent('add_payment_info', gtmData);
export const trackRemoveFromCart = (gtmData) => pushGtmEvent('remove_from_cart', gtmData);
export const trackPurchase = (gtmData) => pushGtmEvent('purchase', gtmData);
